module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('commisionSetup', {
    ref: "commisionSetup"
  }), _vm._v(" "), _c('commisionList', {
    ref: "deleteData",
    on: {
      "delete-message": _vm.deleteCommision,
      "edit-commision": _vm.editCommision
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52a8d25a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/settings/CommisionSetup/commision.vue
// module id = 2231
// module chunks = 0